module.exports = __webpack_public_path__ + "img/sfz2.png";